import {Injectable} from '@angular/core';
import {TableauPage} from '@models/sidebar/response/tableau-page';
import * as _ from 'lodash';
import {OffsetType} from '@models/pages/tableau-page/offset-type';
import {TableauFilterItem} from '@models/pages/tableau-page/tableau-filter-item';

@Injectable({
  providedIn: 'root'
})
export class TableauPageHelperService {

  public generateTableauFilters(tableauPageDetails: TableauPage): TableauFilterItem[] {
    const filters: TableauFilterItem[] = [];
    this.parseAdditionalParameters(tableauPageDetails.additionalParameters, filters);

    this.parsePeriodParameters(tableauPageDetails, filters);

    return filters;
  }

  private parsePeriodParameters(tableauPageDetails: TableauPage, filters: TableauFilterItem[]) {
    const startTimeParameterValue = tableauPageDetails.startTimeParameterValue;
    const endTimeParameterValue = tableauPageDetails.endTimeParameterValue;
    const intervalType = tableauPageDetails.startTimeOffsetType;
    const intervalValue = tableauPageDetails.startTimeOffsetValue;
    const endTimeParameterName = tableauPageDetails.endTimeParameterName;
    const startWithTime = !tableauPageDetails.useStartTimeOnlyDate;
    const endWithTime = !tableauPageDetails.useEndTimeOnlyDate;
    let endDate = new Date(new Date().setMilliseconds(0));
    if (endTimeParameterName) {
      if (tableauPageDetails.useEndTimeParameterValue && endTimeParameterValue) {
        if (_.isDate(endTimeParameterValue)) {
          endDate = endTimeParameterValue;
        } else if (!Number.isNaN(Number(endTimeParameterValue))) {
          endDate = new Date(endTimeParameterValue);
        }
      }
      const filter = new TableauFilterItem(endTimeParameterName, this.formatDateParameterValue(endDate, endWithTime));
      filters.push(filter);
    }

    const startTimeParam = tableauPageDetails.startTimeParameterName;
    if (startTimeParam) {
      let startDate = new Date();
      if (tableauPageDetails.useStartTimeParameterValue && startTimeParameterValue) {
        if (_.isDate(startTimeParameterValue)) {
          startDate = startTimeParameterValue;
        } else if (!Number.isNaN(Number(startTimeParameterValue))) {
          startDate = new Date(startTimeParameterValue);
        }
      } else {
        if (intervalType && intervalValue) {
          startDate = this.calculateOffsetStartDate(intervalValue, endDate, intervalType);
        }
      }
      const filter = new TableauFilterItem(startTimeParam, this.formatDateParameterValue(startDate, startWithTime));
      filters.push(filter);
    }

  }

  private parseAdditionalParameters(additionalParameters: string, filters: TableauFilterItem[]) {
    if (!additionalParameters || additionalParameters.isNullOrWhitespace()) {
      return;
    }

    additionalParameters = additionalParameters.trimWhiteSpaces();
    const arrayOfParameters = additionalParameters.replace('&amp;', '&').split(/[?]|&|%3F|%26/);
    for (const parameter of arrayOfParameters) {
      if (!parameter.includes('=')) {
        continue;
      }

      const parts:string[] = parameter.split('=');
      const index:number = filters.findIndex(f => f.field === parts[0]);
      if (index < 0) {
        filters.push(new TableauFilterItem(parts[0], parts[1].replace('%20', ' ')));
      }
    }
  }

  private formatDateParameterValue(date, includeTimeComponent) {
    const yyyy = date.getFullYear();
    const MM = date.getMonth() < 9 ? '0' + (date.getMonth() + 1)
        : (date.getMonth() + 1); // getMonth() is zero-based
    const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    let result = yyyy + '-' + MM + '-' + dd;
    if (includeTimeComponent) {
      result += ' ' + hh + ':' + mm + ':' + ss;
    }
    return result;

  }


  private calculateOffsetStartDate(offsetValue: number, currentDate: Date, offsetType?: string) {

    if (!offsetType) {
      return currentDate;
    }

    switch (offsetType) {
      case OffsetType.HOUR:
        currentDate.setHours(currentDate.getHours() - offsetValue);
        break;
      case OffsetType.DAY:
        currentDate.setDate(currentDate.getDate() - offsetValue);
        break;
      case OffsetType.WEEK:
        currentDate.setDate(currentDate.getDate() - (7 * offsetValue));
        break;
      case OffsetType.MONTH:
        currentDate.setMonth(currentDate.getMonth() - offsetValue);
        break;
      case OffsetType.YEAR:
        currentDate.setFullYear(currentDate.getFullYear() - offsetValue);
        break;
    }
    return currentDate;
  }
}
